/**
 * @generated SignedSource<<d96852231997fe715bb3ed49321984e4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ExpenseCategory = "CONSULTING_AND_ADMINISTRATION" | "HARDWARE_AND_EQUIPMENT" | "INFRASTRUCTURE" | "INSURANCE" | "MEMBERSHIPS_AND_DONATIONS" | "OTHER" | "SERVICES_AND_LICENSES" | "TRAVEL" | "VEHICLES" | "%future added value";
export type OverrideExpenseInvoiceCategoryInput = {
  expenseCategory: ExpenseCategory;
  id: string;
};
export type IncomingInvoiceViewOverrideCategoryMutation$variables = {
  input: OverrideExpenseInvoiceCategoryInput;
};
export type IncomingInvoiceViewOverrideCategoryMutation$data = {
  readonly overrideExpenseInvoiceCategory: {
    readonly expenseCategory: ExpenseCategory | null | undefined;
    readonly expenseCategoryOverride: ExpenseCategory | null | undefined;
    readonly id: string;
  };
};
export type IncomingInvoiceViewOverrideCategoryMutation = {
  response: IncomingInvoiceViewOverrideCategoryMutation$data;
  variables: IncomingInvoiceViewOverrideCategoryMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ExpenseInvoice",
    "kind": "LinkedField",
    "name": "overrideExpenseInvoiceCategory",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "expenseCategory",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "expenseCategoryOverride",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IncomingInvoiceViewOverrideCategoryMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IncomingInvoiceViewOverrideCategoryMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a1b6cf61353a40f14a3f09b396b62c45",
    "id": null,
    "metadata": {},
    "name": "IncomingInvoiceViewOverrideCategoryMutation",
    "operationKind": "mutation",
    "text": "mutation IncomingInvoiceViewOverrideCategoryMutation(\n  $input: OverrideExpenseInvoiceCategoryInput!\n) {\n  overrideExpenseInvoiceCategory(input: $input) {\n    id\n    expenseCategory\n    expenseCategoryOverride\n  }\n}\n"
  }
};
})();

(node as any).hash = "ee3a02d7eab16565a3751b7e75508479";

export default node;
